<div class="grid-container margin-top margin-bottom">
  <div class="grid-x">
    <div class="cell small-2 large-1 medium-1 padding-right">
      <!--<a class="small-font-size" (click)="goBack()">&laquo; Back</a>-->
    </div>
    <div class="cell small-10 medium-11 large-11">
      @if (showCriticalNotes) {
        <critical-notes [organization]="organization" [relationType]="noteTypes.Organization"></critical-notes>
      }
    </div>
  </div>
  <div class="grid-x border-bottom-medium-gray margin-top">
    <div class="cell small-4 large-4 medium-4">
      <h4 class="no-margin-bottom">{{ organization?.name }}</h4>
    </div>
    <div class="cell small-3 medium-3 large-3">
      &nbsp;@if (cancellationDate) {
      <span class="red bold">Organization Cancelled on {{ cancellationDate | date: 'MM/dd/yyyy':'+0000'  }} </span>
    }
    @if (enforcementExhaustedDate) {
      <span class="red bold">Enforcement Exhausted on {{ enforcementExhaustedDate | date: 'MM/dd/yyyy':'+0000'}}</span>
    }
  </div>
  @if (editingActive == false) {
    <div class="cell small-5 medium-5 large-5 text-align-right">
      Organization Entity Type: {{ typeDescription }}
      @if (canEdit) {
        <button (click)="editingActive = !editingActive" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="edit" aria-describedby="editIcon"></svg-icon>
        </button>
      }
      <span class="show-for-sr" id="editIcon">Edit Organization Entity Type</span>
    </div>
  } @else {
    <div class="cell small-5 medium-5 large-5 text-align-right">
      Organization Entity Type:
      <select [(ngModel)]="typeDescrip">
        @for (type of typeValues; track type) {
          <option [value]="type.Code">{{type.Definition}}</option>
        }
      </select>
      <button id="updateType" aria-describedby="updateTypeButton" class="button" (click)="update()">
        <svg-icon icon="icon-save" class="small black" id="updateTypeIcon"></svg-icon>
      </button>
      <span class="show-for-sr" id="updateTypeButton">Update Entity Type</span>
    </div>
  }
</div>
<router-outlet></router-outlet>
</div>